// extracted by mini-css-extract-plugin
module.exports = {"burgerIcon":"po","cross":"pp","iconSVGWrapper":"pq","iconSVG":"pr","iconSVGDark":"ps"};